$(document).ready(function(){
	//Login
    $('.forgot-link').click(function(){$('#login-box').hide(); $('#recover-box').show();});
    $('.cancel-forgot').click(function(){$('#recover-box').hide(); $('#login-box').show();});

    //Sidebar actions
    $('#customer-account').click(function(){
    	$('.sidebar-button').removeClass('sidebar-button-active');
    	$(this).addClass('sidebar-button-active');
    	$('#orders-table, #addresses-table, #account-table, .address-main').fadeIn();
    	$('.over-order, .addresses-list, .edit-address, .addresses-info-note').hide();
    });

    $('#customer-orders, .go-orders').click(function(){
    	$('.sidebar-button').removeClass('sidebar-button-active');
    	$(this).addClass('sidebar-button-active');
    	$('#orders-table, #addresses-table, #account-table, .addresses-list, .edit-address, .addresses-info-note').hide();
    	$('#orders-table, .address-main').fadeIn();
    	$('.over-order').css('display', 'table-row');
    });

    $('#customer-addresses').click(function(){
    	$('.sidebar-button').removeClass('sidebar-button-active');
    	$(this).addClass('sidebar-button-active');
    	$('#orders-table, #addresses-table, #account-table, .over-order, .address-main, .edit-address').hide();
    	$('#addresses-table, .addresses-list, .addresses-info-note').fadeIn();
    });

    //Addresses Editor
    $('.open-address-editor').click(function(){$('.edit-address').hide(); $(this).closest('.row').find('.edit-address').fadeIn();});
    $('.edit-address button[type="reset"]').click(function(){$('.edit-address').hide();})
}); //ready